// ----- DO NOT MODIFY THIS FILE DIRECTLY -----
// This file was generated in this project by stack9-cli tool from stack9-instance-template repository.
// If you want to make changes to this file, please edit the template file in the stack9-instance-template repository...
// ...and re-run stack9-cli commands to upgrade your stack9 core components.
//
// For more information about stack9-cli and stack9-instance-template, please visit:
// - stack9-cli: https://github.com/april9au/stack9-cli
// - stack9-instance-template: https://github.com/april9au/stack9-instance-template
// ----- DO NOT MODIFY THIS FILE DIRECTLY -----

import { createRoot } from 'react-dom/client';

import { reportWebVitals } from '@april9au/stack9-ui';

import '@april9au/stack9-ui/dist/index.css';

import { Stack9InstanceFrontend } from './app.stack9.instance';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<Stack9InstanceFrontend />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
